export const PRODUCT_VERSION_APP_NAME = 'stai-api';
export const NOT_AVAILABLE = 'N/A';
